import React from 'react';
import './ContactForm.css';

const ContactForm = () => {
  return (
    <div className="contact-form-container">
      <a href="https://portafolio-vlobos.web.app" target="_blank" rel="noopener noreferrer">
        <img src="img/vlobos.png" alt="Logo" className="logo" />
      </a>
    </div>
  );
};

export default ContactForm;

